import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Img } from './data/img';
import { Media } from './data/media';
import { Article } from './data/article';
import { Critere } from './data/critere';
import { Formation } from './data/formation';
import { Ecole } from './data/ecole';
import { Admission } from './data/admission';
import { Faculte } from './data/faculte';
import { Metier } from './data/metier';
import { Job } from './data/job';

@Injectable()
export class EventSendeurService {
  childrens = {href: "gggg", typeTarget: "gggg",target:"ggggg",title:"ggg",name:"ggg",id:0,childrens: []}
  public pageSendeur: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  // public article: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public message: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public user: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public category: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public commentaire: BehaviorSubject<[9]> = new BehaviorSubject<any>([]);
  public menu: BehaviorSubject< {href: "gggg", typeTarget: "gggg",target:"ggggg",title:"ggg",name:"ggg",id:0,childrens: []}> = new BehaviorSubject<any>([]);
  public fichier: BehaviorSubject<Media> = new BehaviorSubject<Media>(new Media);
  public image: BehaviorSubject<Img> = new BehaviorSubject<Img>(new Img);
  public article: BehaviorSubject<Article> = new BehaviorSubject<Article>(null);

  public agendaDelete : BehaviorSubject<[1]> = new BehaviorSubject<any>([]);
  public carousel : BehaviorSubject<[1]> = new BehaviorSubject<any>([]);

  public critere: BehaviorSubject<Critere> = new BehaviorSubject<Critere>(new Critere);
  public formation: BehaviorSubject<Formation> = new BehaviorSubject<Formation>(new Formation);
  public metier: BehaviorSubject<Metier> = new BehaviorSubject<Metier>(new Metier);
  public job: BehaviorSubject<Job> = new BehaviorSubject<Job>(new Job);
  public ecole: BehaviorSubject<Ecole> = new BehaviorSubject<Ecole>(new Ecole);
  public admission: BehaviorSubject<Admission> = new BehaviorSubject<Admission>(new Admission);
  public facult: BehaviorSubject<Faculte> = new BehaviorSubject<Faculte>(new Faculte);
 
  // currentFile = this.fichier.asObservable();
  // currentImage = this.image.asObservable();
  currentDeleteEvent =  this.agendaDelete.asObservable();
  pageEvent = this.pageSendeur.asObservable();
  messageCourant = this.message.asObservable();
  // articleEvent = this.article.asObservable();
  userEvent = this.user.asObservable();
  commentaireEvent = this.commentaire.asObservable();
  categoryEvent = this.category.asObservable();
  menuEvent = this.menu.asObservable();
  // articleSubscription =this.carousel.asObservable();

  critereEvent = this.critere.asObservable();

  formationEvent = this.formation.asObservable();

  metierEvent = this.metier.asObservable();
  jobEvent = this.job.asObservable();

  ecoleEvent = this.ecole.asObservable();

  admissionEvent = this.admission.asObservable();

  facultEvent = this.facult.asObservable();

  constructor() { }

  sendPageEvent(data){
    this.pageSendeur.next(data);
  }

  /* sendFile(data){
    this.fichier.next(data);
    this.fichier.asObservable().subscribe(data => {

    })
  } */

  sendMessage(data){
    this.message.next(data);
  }

sendCategoryEvent(data){
    this.category.next(data);
}
sendMenuEvent(data){
    this.menu.next(data);
}

  sendUserEvent(data){
    this.user.next(data);
}
  /* sendCommentaireEvent(data){
    this.commentaire.next(data);
  } */

 /*  sendArticleEvent(data){
    this.article.next(data);
  } */


sendCritereEvent(data){
    this.critere.next(data);
}

sendFormationEvent(data){
  this.formation.next(data);
}

sendMetierEvent(data){
  this.metier.next(data);
}

sendJobEvent(data){
  this.job.next(data);
}

sendEcoleEvent(data){
  this.ecole.next(data);
}

sendAdmissionEvent(data){
  this.admission.next(data);
}

sendFacultEvent(data){
  this.facult.next(data);
}

 
}
